'use client'
import { useParams } from 'next/navigation'
import type { z } from 'zod'

function useValidatedParams<TSchema extends z.Schema>(schema: TSchema): z.infer<TSchema> | null {
  const params = useParams()
  const validated = schema.safeParse(params)
  if (!validated.success) return null
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return validated.data
}

export default useValidatedParams
